import { render, staticRenderFns } from "./wl_select.vue?vue&type=template&id=1ea28a72"
import script from "./wl_select.vue?vue&type=script&lang=js"
export * from "./wl_select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports